import globalStore from '@/store/global';
import userStore from '@src/store/user';
import appLogger from '@public/log/monitor';

const LoginBtn = ({ className }) => {
  return (
    <div
      onClick={() => {
        appLogger.log({
          key: 'aibot_navbar',
          action: 'click',
          arrt: 'login',
        });
        userStore.gotoLogin();
      }}
      className={[
        'h-40px flex items-center justify-center', // Added justify-center for centering text
        globalStore.isDark ? 'bg-gray-nav' : 'bg-[#FFF]',
        'text-primary border-1px border-solid rounded-8px cursor-pointer border-[#000000] hover:bg-[#00000003]', // Changed border color to red
        className,
      ]}
    >
      <div className="text-14px font-bold text-black text-center">登录以同步历史会话</div>
    </div>
  );
};

export default LoginBtn;
